module.exports = __webpack_public_path__ + "static/media/bg_intro_content.f6791cc6.png";